import { connect } from 'react-redux';
import { getTheme } from 'app/api/redux-watson/watson-config-selectors';

const mapStateToProps = state => ({
  theme: getTheme(state),
});

export default function withTheme(ThemedComponent) {
  return connect(mapStateToProps)(ThemedComponent);
}
